const getMarketplaceIdFromLocation = () => {
    const marketplaceId = window.location.pathname.split('/')[1];
    return marketplaceId;
}

export {getMarketplaceIdFromLocation}